export const NAME = 'password';

export const REQUEST_UPDATE_PASSWORD = 'REQUEST_UPDATE_PASSWORD';
export const SUCCESS_UPDATE_PASSWORD = 'SUCCESS_UPDATE_PASSWORD';
export const FAILURE_UPDATE_PASSWORD = 'FAILURE_UPDATE_PASSWORD';

export const RESET_FORM_SUBMIT_UPDATE_PASSWORD = 'RESET_FORM_SUBMIT_UPDATE_PASSWORD';



// WEBPACK FOOTER //
// ./src/services/account/password/constants.js